// src/components/Navbar.jsx
import React from 'react';
import './Navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Navbar() {
  return (
    <nav className="navbar custom-navbar">
      <div className="container d-flex align-items-center justify-content-between">
        {/* Branding */}
        <a className="navbar-brand d-flex align-items-center" href="https://upass.gr/">
                  <span className="brand-text2">Tickets by </span>

          <img
            src="https://upass.gr/logotransparent.png"
            alt="U-Pass Λογότυπο"
            className="brand-logo"
          />
          <span className="brand-text">U-Pass</span>
        </a>

     
      </div>
    </nav>
);
}
